import type { CalendarEmployeeFilterValue } from './components/TimeOffCalendarEmployeeFilter';
import type { TimeOffCalendarOrgFilter } from './components/TimeOffCalendarOrgFilter';

export function countActiveCalendarFilters(
  employeeFilter: CalendarEmployeeFilterValue | null,
  orgFilter: TimeOffCalendarOrgFilter
): number {
  let count = 0;
  if (employeeFilter) count += 1;
  if (orgFilter.kind !== 'all') count += 1;
  return count;
}

export function summarizeCalendarFilters(
  employeeFilter: CalendarEmployeeFilterValue | null,
  orgFilter: TimeOffCalendarOrgFilter
): string {
  const parts: string[] = [];
  if (employeeFilter) {
    parts.push(employeeFilter.displayName.trim() || employeeFilter.upn);
  }
  if (orgFilter.kind === 'company') parts.push(orgFilter.value);
  if (orgFilter.kind === 'department') parts.push(orgFilter.value);
  return parts.join(' · ');
}
